import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const fakePurchases = [{
  name: 'Isabella Robinson',
  location: 'Colorado',
  amount: '$29.97',
  product: 'Voices of Freedom — eBook + Audiobook Bundle',
  time: 'Just now'
}, {
  name: 'Michael T.',
  location: 'Texas',
  amount: '$29.97',
  product: 'Voices of Freedom Digital Bundle',
  time: '2 mins ago'
}, {
  name: 'Sarah Jenkins',
  location: 'Florida',
  amount: '$29.97',
  product: 'Voices of Freedom — eBook + Audiobook Bundle',
  time: '5 mins ago'
}, {
  name: 'David W.',
  location: 'Ohio',
  amount: '$29.97',
  product: 'Voices of Freedom Digital Bundle',
  time: '12 mins ago'
}];
export function SalesPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % fakePurchases.length);
        setIsVisible(true);
      }, 1000);
    }, 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  const currentPurchase = fakePurchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-225">
      <AnimatePresence data-id="element-226">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-lg shadow-2xl border border-gray-200 p-3 flex gap-3 max-w-xs md:max-w-sm pointer-events-auto" data-id="element-227">
            <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden bg-navy" data-id="element-228">
              <img src="https://cdn.magicpatterns.com/uploads/8VhdCTKEB5SoAzmACwizSF/Mockup_Audio_Book_Charlie_Kirk.png" alt="Book Cover" className="w-full h-full object-cover" data-id="element-229" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-230">
              <div className="flex justify-between items-start mb-1" data-id="element-231">
                <p className="text-sm font-bold text-navy truncate pr-2" data-id="element-232">
                  {currentPurchase.name}{' '}
                  <span className="text-gray-400 font-normal text-xs" data-id="element-233">
                    • {currentPurchase.location}
                  </span>
                </p>
                <span className="text-xs text-gray-500 whitespace-nowrap" data-id="element-234">
                  {currentPurchase.time}
                </span>
              </div>
              <p className="text-xs text-gray-600 mb-0.5" data-id="element-235">
                Purchase made:{' '}
                <span className="font-bold text-green-600" data-id="element-236">
                  {currentPurchase.amount}
                </span>
              </p>
              <p className="text-xs text-gray-500 italic truncate" data-id="element-237">
                {currentPurchase.product}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}